import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { QueryParametersRouteValidator } from "./QueryParametersRouteValidator";
import { DistanceLearningRouteValidator } from "./DistanceLearningRouteValidator";
import { IRouteValidator } from "./IRouteValidator";

export class RouteValidatorHandler {
	public handle(to: RouteLocationNormalized, next: NavigationGuardNext): void {

		let changesApplied = false;

		const validators: IRouteValidator[] = [
			new DistanceLearningRouteValidator(),
			new QueryParametersRouteValidator()
		];

		validators.forEach(validator => {
			if (!validator.isValid(to)) {
				validator.applyValidationFix(to);
				changesApplied = true;
			}
		});

		if (changesApplied) {
			next({ path: to.path, query: to.query, replace: true });
		} else {
			next();
		}
	}
}
